import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";
import { Helmet } from "react-helmet-async";


const faqs = [
  {
    q: "What time are guests collected from their hotel?",
    a: "Most temple journeys begin between 4:15 and 4:45am to place you at Angkor Wat before the first light. Your guide confirms the exact pickup the evening prior, and a chilled hand towel, Khmer coffee, and pastries from a Siem Reap bakery wait in the vehicle.",
  },
  {
    q: "Are the itineraries accessible for guests with limited mobility?",
    a: "Several temples — including Angkor Wat's lower causeway, Banteay Kdei, and parts of the Bayon — are navigable with assistance. We design private accessible routes using ramped entrances, paved pathways, and a second guide for support. Please share any requirements when inquiring so we can tailor the day fully.",
  },
  {
    q: "What happens if the weather turns during a tour?",
    a: "Cambodia's monsoon afternoons are part of the temples' character. We provide umbrellas, rain ponchos, and reroute to sheltered galleries — Preah Khan and Ta Prohm are particularly atmospheric in rain. For lightning or flooding, we pause to a tea house and resume once it's safe, extending the day at no cost.",
  },
  {
    q: "What is the cancellation and refund policy?",
    a: "Cancellations made 30 days or more before departure receive a full refund less a 10% administrative fee. Within 14–29 days, 50% is refundable. Inside 14 days, the booking is non-refundable, though we will gladly transfer the value to a future date within 18 months. We do not charge change fees for medical or visa-related rescheduling.",
  },
];

const faqJsonLd = {
  "@context": "https://schema.org",
  "@type": "FAQPage",
  mainEntity: faqs.map((f) => ({
    "@type": "Question",
    name: f.q,
    acceptedAnswer: { "@type": "Answer", text: f.a },
  })),
};

const Faq = () => (
  <section id="faq" className="bg-secondary py-28 md:py-36">
    <Helmet>
      <script type="application/ld+json">{JSON.stringify(faqJsonLd)}</script>
    </Helmet>
    <div className="container max-w-5xl">
      <div className="grid md:grid-cols-[1fr_2fr] gap-16 md:gap-24">
        <div>
          <p className="text-xs uppercase tracking-[0.4em] text-primary mb-5">— Practicalities</p>
          <h2 className="font-display text-4xl md:text-5xl leading-[1.05]">
            Questions, answered before you ask.
          </h2>
          <p className="mt-8 text-muted-foreground leading-relaxed">
            A short field guide to the details that shape every Aṅkor Sojourn.
          </p>
        </div>
        <Accordion type="single" collapsible className="w-full">
          {faqs.map((f, i) => (
            <AccordionItem key={i} value={`item-${i}`} className="border-foreground/15">
              <AccordionTrigger className="font-display text-xl md:text-2xl text-left hover:no-underline hover:text-primary py-6">
                {f.q}
              </AccordionTrigger>
              <AccordionContent className="text-base text-muted-foreground leading-relaxed pb-6">
                {f.a}
              </AccordionContent>
            </AccordionItem>
          ))}
        </Accordion>
      </div>
    </div>
  </section>
);

export default Faq;
